// import $ from 'jquery';
// window.$ = window.jQuery = $;
import Cookie from './Cookie';
import { jarallax } from 'jarallax';
import simplebar from 'simplebar/dist/simplebar';

let cookie = new Cookie(true);
cookie.init();

$('.wpcf7-list-item-label a').click(function (e) {
    e.preventDefault();
});

$('.gallery').each(function (i, s) {
    var $this = $(this);
    var id = $this.attr('id');
    var figcaption = $this.find('figcaption');
    if (figcaption.length > 0) {
        figcaption.each(function () {
            var figitem = $(this);
            var figtext = figitem[0].outerText;
            figitem.parent().find('a').attr('data-caption', figtext)
        });
    }
    $this.find('a').attr('data-fancybox', id);
});

jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.1
});

const nav = document.querySelector('.navbar');
window.addEventListener('scroll', () => {
    let scrollPosY = window.pageYOffset | document.body.scrollTop;
    if (scrollPosY > 200) {
        nav.classList.add('is-scrolled');
    } else {
        nav.classList.remove('is-scrolled');
    }
});

$(document).ready(function () {
    var hash = document.location.hash;
    if (hash.length > 0) {
        $('html, body').delay(100).animate({
            scrollTop: $(hash).offset().top - 80
        }, 'slow');
    };
});



// WEBPACK FOOTER //
// ./wp-content/themes/internetmedia/dev/js/app.js